<!--
 * www.cloudscope.cn
 * Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Date: 2019-08-14 11:57:16
 * @Description: 角色表格
-->
<template>
    <div class="table-list">
        <div class="header">
            <p class="title">{{title}}</p>
        </div>
        <el-table
            :data="tableData"
            class="mod-table"
            style="margin-top:19px"
            height="250"
            v-loading="loading"
        >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
                type="index"
                align="center"
                width="80"
                label="序号"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="code" align="center" label="编码" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" align="center" label="名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createdate" align="center" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showDialog(scope.row.id)">编辑</el-button>
                    <el-button
                        type="text"
                        size="small"
                        @click="DeleteShow(scope.$index,scope.row.id)"
                    >删除</el-button>
                    <el-button
                        type="text"
                        size="small"
                        @click="showAddMenu(scope.$index, tableData)"
                    >权限</el-button>
                </template>
            </el-table-column>
        </el-table>
        <footer class="main-footer">
            <!-- 底部分页 -->
            <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                @size-change="handleSizeChange"
                @next-click="changePage"
                @prev-click="changePage"
                @current-change="changePage"
            ></el-pagination>
        </footer>

        <!-- 菜单授权 Dialog: Begin -->
        <el-dialog
            title="权限分配"
            custom-class="mod-dialog"
            append-to-body
            :visible.sync="MenuTreedialogVisible"
            width="820px"
        >
            <div class="main-contain">
                <div style="height: 500px">
                    <el-row :gutter="16">
                        <el-col :span="7">
                            <el-card style="height: 500px; overflow: scroll;">
                                <el-tree
                                    accordion
                                    :data="menuTree"
                                    :props="defaultProps"
                                    @node-click="querySubPermission"
                                ></el-tree>
                            </el-card>
                        </el-col>
                        <el-col :span="17">
                            <el-card style="height: 500px; overflow: scroll;">
                                <el-table
                                    :data="menuSubAccess"
                                    :row-key="getRowKeys"
                                    :expand-row-keys="expands"
                                    class="mod-table"
                                    :row-class-name="tabRowClassName"
                                >
                                    <!-- <el-table-column type="selection" width="60"></el-table-column> -->
                                    <el-table-column prop="permissionType" align="center" label="权限类型"></el-table-column>
                                    <el-table-column prop="parentMenu" align="center" label="归属菜单"></el-table-column>
                                    <el-table-column prop="permissionName" align="center" label="权限名称"></el-table-column>
                                    <el-table-column width="82" label="权限开关" align="center">
                                        <template slot-scope="scope">
                                            <div class="link-icon-group" style="text-algin:center">
                                                <!-- <a href="javascript:void(0)" class="link-icon" title="删除" @click="deleteRole(scope.$index, tableData)"><i class="icon-remove"></i></a>  -->
                                                <el-switch
                                                    v-model="menuSubAccess[scope.$index].hasPermission"
                                                    style="margin: auto;"
                                                    @change="change(scope.row)"
                                                    active-color="#409eff"
                                                    inactive-color="#dcdfe6"
                                                ></el-switch>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-card>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>
        <!-- 菜单授权 Dialog: Begin -->
    </div>
</template>

<script>
export default {
    components: {},
    props: ['title'],
    data () {
        return {
            tableData: [],
            loading: true,
            currentPage: 1, // 当前页
            pageSize: 10, // 每页数量
            total: 0, // 总数
            RoleForm: {
                // 角色数据
                id: '',
                name: '',
                code: '',
                status: 1
            },
            menuTree: [],
            MenuTreedialogVisible: false, // 授权菜单树页面是否可视
            menuSubAccess: [],
            getRowKeys (row) {
                // 获取row的key值
                return row.id;
            },
            expands: [], // 要展开的行，数值的元素是row的key值
            defaultProps: {
                label: 'title'
            },
            roleId: ''
        };
    },
    mounted () {
        this.$nextTick(() => {
            // 创建一个查询的Bean
            let queryBean = this.buildQueryBean();
            this.loadTable(queryBean);
        });
        // eslint-disable-next-line no-extend-native
        Date.prototype.format = function (fmt) {
            var o = {
                'M+': this.getMonth() + 1, // 月份
                'd+': this.getDate(), // 日
                'h+': this.getHours(), // 小时
                'm+': this.getMinutes(), // 分
                's+': this.getSeconds(), // 秒
                'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
                S: this.getMilliseconds() // 毫秒
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(
                    RegExp.$1,
                    (this.getFullYear() + '').substr(4 - RegExp.$1.length)
                );
            }
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length == 1
                            ? o[k]
                            : ('00' + o[k]).substr(('' + o[k]).length)
                    );
                }
            }
            return fmt;
        };
    },
    methods: {
        tabRowClassName ({ row, rowIndex }) {
            let index = rowIndex + 1;
            if (index % 2 == 0) {
                return 'warning-row';
            }
        },
        /**
         * @author: liuc
         * @description: 获取分页信息： total pageSize currentPage
         * @param {data} 分页信息
         */
        paginationInfo (data) {
            this.total = Number(data.total);
            this.pageSize = data.pageSize;
            this.currentPage = data.pageNum;
        },
        /**
         * @author: liuc
         * @description: 新增、编辑后刷新表格
         * @param {}
         */
        async loadTableRefresh () {
            this.$emit('loadlist', this.currentPage);
        },
        /**
         * @author: liuc
         * @description: 获取分页菜单列表
         * @param {queryBean}: 分页参数
         */
        async loadTable (queryBean) {
            // 请求数据
            let response = await this.$api.RoleManagement.getRoleList(
                queryBean
            );
            if (response.code == '200') {
                this.loading = false;
            }
            this.tableData = response.data.list;
            for (var i in this.tableData) {
                var date = new Date(this.tableData[i].createdate).format(
                    'yyyy-MM-dd hh:mm:ss'
                );
                this.tableData[i].createdate = date;
            }
            this.paginationInfo(response.data);
        },
        /**
         * @author: liuc
         * @description: 格式化转换时间
         * @param {date}: 时间戳格式
         */
        getdate (date) {
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            return (
                y +
                '-' +
                (m < 10 ? '0' + m : m) +
                '-' +
                (d < 10 ? '0' + d : d) +
                ' ' +
                date.toTimeString().substr(0, 8)
            );
        },
        /**
         * @author: liuc
         * @description: 分页组件上的：上一页/下一页/页码输入框
         * @param {cp} 当前页码
         */
        changePage (cp) {
            this.currentPage = cp;
            this.$emit('loadlist', cp);
        },
        /**
         * @author: liuc
         * @description: 分页组件上每页显示条数
         * @param {val} 每页条数
         */
        handleSizeChange (val) {
            this.$parent.pageSize = val;
            this.$emit('loadlist', this.currentPage);
        },
        /**
         * @author: liuc
         * @description:打开编辑角色
         * @param {id} 角色id
         */
        showDialog (id) {
            this.$emit('showDialog', id);
        },
        /**
         * @author: liuc
         * @description:打开删除提醒
         * @param {index} 下标
         * @param {id} id
         */
        async DeleteShow (index, id) {
            this.$confirm('确认删除？', '警告', { type: 'warning' })
                .then(async () => {
                    let response = await this.$api.RoleManagement.deleteRole(
                        id
                    );
                    if (response.code == 200) {
                        this.$message.success('删除成功');
                    }
                    // 当删除的记录是最后一页的第一条时,删除后刷新列表到第一页
                    var lastPage =
                        this.total % this.pageSize == 0
                            ? this.total / this.pageSize
                            : Math.floor(this.total / this.pageSize) + 1;
                    if (this.currentPage == lastPage && index == 0) {
                        this.currentPage = 1;
                    }
                    this.loadTable(
                        this.buildQueryBean(this.currentPage, this.pageSize)
                    );
                })
                .catch(() => {});
        },
        /**
         * @author:
         * @description: 点击“权限”，显示角色下发页面
         * @param {index} 下标
         * @param {rows} 当前行信息
         */
        async showAddMenu (index, rows) {
            // 用户主键
            this.roleId = rows[index].id;
            let response = await this.$api.RoleManagement.getMenuTree();
            this.menuTree = response.data;
            // 显示权限分配弹窗
            this.MenuTreedialogVisible = true;
        },
        /**
         * @author:
         * @description: 获取子权限
         * @param {node} 当前节点
         */
        async querySubPermission (node) {
            let data = {
                menuKey: node.id,
                roleKey: this.roleId
            };
            let response = await this.$api.RoleManagement.querySubPermission(
                data
            );
            this.menuSubAccess = response.data;
        },
        /**
         * @author:
         * @description: 改变状态
         * @param {newValue} 改变后的状态
         */
        async change (newValue) {
            newValue.roleId = this.roleId;
            let response = await this.$api.RoleManagement.distributionPermission(
                newValue
            );
            if (response.code !== 200) {
                this.$message.error(response.msg);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.table-list {
    /deep/ .el-loading-mask {
        z-index: 1000;
    }
}
.header {
    .title {
        font-size: 24px;
    }
}
.el-button {
    border: 0;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    line-height: 23px;
    font-size: 12px;
    text-align: left;
    padding: 0;
    background-color: inherit;
}

/* 设置滚动条的样式 */
.el-card::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #fff;
}

/* 滚动槽 */
.el-card::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
.el-card::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #cccccc;
}

/deep/ .el-table {
    .warning-row {
        // background: #ebeef5;
        background: rgba(73, 112, 173, 0.149);
    }
}

.success-row {
    background: #f0f9eb;
}

.el-tree-node:focus > .el-tree-node__content{
    color: #4970AD;
}
</style>



// WEBPACK FOOTER //
// ./src/components/RoleManagement/List.vue